(ns manage.ad-variant.review.hooks
  (:require [common.queries :refer [use-query]]
            [common.resource.query.user :as uq]
            [manage.ad-variant.queries :as q]
            [mate.core :as mc]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-users-doing-qc-reviews []
  (let [{:keys [agency-id adset-id]} (use-subscribe [:url-context])
        {{:keys [user-mappings]} :data} (use-query (q/review-query {:adset-id adset-id}))
        {users :data} (use-query (uq/users-query {:agency-id agency-id}))
        user-id->user (mc/index-by :id users)]
    (mapv
     (fn [mapping]
       (let [user-name (:name (get user-id->user (:user-request-mapping/user-id mapping)))]
         (assoc mapping :user-request-mapping/user-name user-name)))
     user-mappings)))
